<h3>{{'help.formStep.step1'|translate }}</h3>
<mat-accordion [multi]="true" displayMode="flat" class="accordion-container">
  <mat-expansion-panel *ngFor="let video of (videosHelps$ | async)" [togglePosition]="'after'">
    <mat-expansion-panel-header>
      <mat-panel-title>
        <div class="content">
          <div class="icon"><img [src]="'assets/svg-icons/tutorial.svg'" [alt]="video?.attributes?.title" /></div>
          <div class="video-title">{{ video?.attributes?.title}}</div>
          <div class="link">    </div>
        </div>
      </mat-panel-title>
    </mat-expansion-panel-header>
    <ng-template matExpansionPanelContent>
      <hr />
      <div class="videoContent">
        <iframe [src]="getSafeVideoUrl(video?.attributes?.videoId)"
        allow="autoplay; fullscreen; picture-in-picture"
        [title]="video?.attributes?.title"></iframe>
      </div>
    </ng-template>
  </mat-expansion-panel>
</mat-accordion>
